app.factory('produtoRedeFundoFactory', function ($http, errorService) {

    var _apiName = 'ProdutoRedeFundo';
    var _codigoProdutoRede = '00000000-0000-0000-0000-000000000000';

    var _setParams = function (codigoProdutoRede) {
        _codigoProdutoRede = codigoProdutoRede;
    };

    var _addNew = function () {
        var dto = {}
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/NovoFundo', dto);
    }

    var _list = function (search, options) {
        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProdutoRede", "value": _codigoProdutoRede });
        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListaFundosByProdutoRede', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };
    var _listarCodigosVersaoCessao = function (codigoProdutoRede) {
        var dto = {}
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });
        dto.parms.push({ "name": "TipoLayout", "value": "2" });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarCodigoVersaoDeProdutoRedeFormularioByCodigoProdutoRede', dto);
    };

    var _listarCodigosVersaoEndosso = function (codigoProdutoRede) {
        var dto = {}
        dto.parms = [];
        dto.parms.push({ "name": "CodigoProdutoRede", "value": codigoProdutoRede });
        dto.parms.push({ "name": "TipoLayout", "value": "4" });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarCodigoVersaoDeProdutoRedeFormularioByCodigoProdutoRede', dto);
    };

    var _save = function (request) {
        //Criação do JSON dos Fundos
        switch (request.ProdutoRedeFundo.TipoLayoutFundo) {
            case '106': //ARTESANAL
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeArtesanal);
                break;
            case '107': //ASA BANK
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeAsaBank);
                break;
            case '113': //BROOKFIELD
            case '117': //BROOKFIELD II
            case '118': //BROOKFIELD III
            case '119': //BROOKFIELD IV
            case '120': //BROOKFIELD V
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeBrookfield);
                break;
            case '109': //BTG PACTUAL
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeBTG);
                break;
            case '103': //CM CAPITAL
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeCMCapital);
                break;
            case '110': //FIDD
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeFIDD);
                break;
            case '104': //FINAXIS
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeFinaxis);
                break;
            case '108': //FROMTIS
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeFromtis);
                break;
            case '111': //GENIAL
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeGenial);
                break;
            case '101': //INTRADER
            case '121': //INTRADER II
            case '129': //INTRADER III
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeIntrader);
                break;
            case '105': //OLIVEIRA TRUST
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeOliveiraTrust);
                break;
            case '114': //POLIGONO
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedePoligono);
                break;
            case '100': //SOCOPA
            case '128': //SOCOPA II
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeSocopa);
                break;
            case '102': //VORTX
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeVortx);
                break;
            case '116': //BTG HUB
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeBTGHUB);
                break;
            case '122': //AUGME CAPITAL
            case '126': //AUGME CAPITAL II   
            case '127': //AUGME CAPITAL III   
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeAugmeCapital);
                break;
            case '123': //INTEGRAL
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeIntegral);
                break;
            case '124': //OPEX
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeOpex);
                break;
            case '125': //OPEX II
                request.ProdutoRedeFundo.JSONConfiguracao = JSON.stringify(request.ProdutoRedeFundo.produtoRedeOpex);
                break;
            default:
                break;
        }

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/SalvarFundo', request);
    };

    var _delete = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/RemoverFundo', dto);
    };

    var _alterarNomeCampoComissao = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AlterarNomeCampoComissao', dto);
    };

    var _alterarNomeCampoComissaoRenegociacao = function (dto) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AlterarNomeCampoComissaoRenegociacao', dto);
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _adicionaFundos = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/AdicionaFundos');
    };

    var _listarTipoProdutoPoligono = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarTipoProdutoPoligono');
    };

    var _listarTipoCobrancaPoligono = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarTipoCobrancaPoligono');
    };

    var _listarComIntegracaoCessaoCallback = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarComIntegracaoCessaoCallback');
    };
    var _listarTipoRecebivelCMCapital = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarTipoRecebivelCessao');
    };

    var _listarTipoEventoCMCapital = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarTipoEventoCessao');
    }

    var _listarComEndosso = function (tipoLayoutFundo) {
        var dto = {};
        dto.parms = [];
        dto.parms.push({ "name": "TipoLayoutFundo", "value": tipoLayoutFundo });
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarComEndosso', dto);
    };

    var _listarIdentificadoresRegistroCCB = function () {
        var padroesIdentificadores = [];
        padroesIdentificadores.push({ value: 0, text: "ID de Registro CCB" });
        padroesIdentificadores.push({ value: 1, text: "IPOC com ID CCB Externo" });
        padroesIdentificadores.push({ value: 2, text: "IPOC com ID CCB Interno" });
        return padroesIdentificadores;
    }

    var factory = {};

    factory.addNew = _addNew;
    factory.list = _list;
    factory.findRecord = _findRecord;
    factory.save = _save;
    factory.delete = _delete;
    factory.setParams = _setParams;
    factory.adicionaFundos = _adicionaFundos;
    factory.alterarNomeCampoComissao = _alterarNomeCampoComissao;
    factory.listarTipoProdutoPoligono = _listarTipoProdutoPoligono;
    factory.listarTipoCobrancaPoligono = _listarTipoCobrancaPoligono;
    factory.listarComIntegracaoCessaoCallback = _listarComIntegracaoCessaoCallback;
    factory.listarCodigosVersaoCessao = _listarCodigosVersaoCessao;
    factory.listarCodigosVersaoEndosso = _listarCodigosVersaoEndosso;
    factory.listarTipoRecebivelCMCapital = _listarTipoRecebivelCMCapital;
    factory.listarTipoEventoCMCapital = _listarTipoEventoCMCapital;
    factory.AlterarNomeCampoComissaoRenegociacao = _alterarNomeCampoComissaoRenegociacao;
    factory.listarComEndosso = _listarComEndosso;
    factory.listarIdentificadoresRegistroCCB = _listarIdentificadoresRegistroCCB;

    return factory;

});